module.exports = __webpack_public_path__ + "static/media/sidebar-2.e329a438.jpeg";